export const headingInputs = [
  {
    name: "tag",
    type: "string",
    enum: ["h1", "h2", "h3", "h4", "h5", "h6", "div", "span", "p"],
    defaultValue: "h1",
  },
  {
    name: "variant",
    type: "string",
    enum: ["h1", "h2", "h3", "h4", "h5", "h6"],
    defaultValue: "h1",
  },
  // COM-884: rich text so Enter adds a line; each line renders as a <br>
  // inside the one heading, never a second heading.
  {
    name: "content",
    type: "richText",
    defaultValue: "Heading",
  },
];
